export default [
    ['INI', '界面初始化'],
    ['OTH', '其他'],
]
